module.exports = __webpack_public_path__ + "img/album18_15.e324486b.jpg";